import Vue from 'vue'
import VueRouter from 'vue-router'

import Landing from './components/Home.vue';
import Landing2 from './components/Home2.vue';
import LandingDental from './components/HomeDental.vue';
import LandingVA from './components/HomeVA.vue';
import EventManagement from './components/EventManagement.vue';
import MobileApp from './components/MobileApp.vue'
import PortfolioManager from './components/PortfolioManager.vue'
import NewbornCare from './components/NewbornCare.vue';
import ProSitterApp from './components/ProSitterApp.vue';
import ProSitterAppUK from './components/ProSitterAppUK.vue';
import DentalAgencyApp from './components/DentalAgencyApp.vue';
import ElderlyCareApp from './components/ElderlyCareApp.vue';
import MedicalAgencyApp from './components/MedicalAgencyApp.vue';
import AuPairAgencySoftware from './components/AuPairAgencySoftware';

import DemoVideo from './components/DemoVideo.vue';
import DemoVideoNanny from './components/DemoVideoNanny.vue';
import DemoVideoDental from './components/DemoVideoDental.vue';
import DemoVideoHousehold from './components/demovideos/DemoVideoHousehold';
import DemoVideoStaffing from './components/demovideos/DemoVideoStaffing';
import DemoVideoVA from './components/demovideos/DemoVideoVA';
import DemoVideoElderlyCare from './components/demovideos/DemoVideoElderly';
import BackupCareAssistant from './components/demovideos/BackupCareAssistant';
import DemoVideoEvent from './components/demovideos/DemoEventChildcare';
import DemoVideoApp from './components/demovideos/DemoVideoApp';
import DemoVideoNewbornCare from './components/demovideos/DemoVideoNewbornCare'

// Demo Booking Pages
import BookDemo from './components/BookDemo.vue';
import BookDemoApp from './components/BookDemoApp.vue';
import BookDemoGeneral from './components/BookDemoGeneral.vue';
import BookDemoPortfolioManager from './components/BookDemoPortfolioManager.vue';
import BookDemoEventChildcare from './components/demobooking/BookDemoEventChildcare';
import BookDemoRewardsIncentives from './components/demobooking/BookDemoRewardsIncentives.vue';
import BookDemoNewbornCare from './components/demobooking/BookDemoNewbornCare.vue';
import BookDemoCleaningAgency from './components/demobooking/BookDemoCleaningAgency.vue';

// Meeting Booking Pages
import MeetDanny from './components/meetings/MeetDanny.vue';
import MeetAakash from './components/meetings/MeetAakash.vue';
import MeetFalak from './components/meetings/MeetFalak.vue';
import MeetAlejandro from './components/meetings/MeetAlejandro.vue';

import Contact from './components/Contact.vue';
import Directory from './components/Directory.vue';
import TicketForm from './components/TicketForm.vue';
import Jobs from './components/Jobs.vue';
import ThankYou from './components/ThankYou.vue';
import ThankYou2 from './components/ThankYou2.vue';
import ThankYouApp from './components/thankyous/ThankYouApp.vue';

import StripeConnectConfirmation from './components/StripeConnectConfirmation'

// Community Conversations
import HowToUseLinkedin from './components/communityconversations/HowToUseLinkedin'
import EffectiveHiringTips from './components/communityconversations/EffectiveHiringTips'
import MarketingEmailsWebinarsPodcasts from './components/communityconversations/MarketingEmailsWebinarsPodcasts'
import EventCare from './components/communityconversations/EventCare'
import CreativeWaysToGetNewClients from './components/communityconversations/CreativeWaysToGetNewClients'
import UsingEnginehireEmailtoEngageClientsandCandidates from './components/communityconversations/UsingEnginehireEmailtoEngageClientsandCandidates'
import EffectiveHiringTipsForYourAgencysStaffingandYourCandidateRecruiting from './components/communityconversations/EffectiveHiringTipsForYourAgencysStaffingandYourCandidateRecruiting'

// Webinars
import ModelsOfNannyCare from './components/Webinars/ModelsOfNannyCare'

// Tutorials
import HowToSellGiftCards from './components/tutorials/HowToSellGiftCards.vue';

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Landing2, name: 'Home' },
  { path: '/nanny-agency-software', component: Landing2, name: 'Home' },
  { path: '/nanny-agency-management-software', component: Landing2, name: 'Home' },
  { path: '/2', component: Landing, name: 'Home2' },
  { path: '/dental', component: LandingDental, name: 'Home Dental' },
  { path: '/va', component: LandingVA, name: 'Home VA' },
  { path: '/event-childcare-management-software', component: EventManagement, name: 'Event Childcare Management Software' },
  { path: '/pro-sitter-app-for-childcare-nanny-agencies', component: ProSitterApp, name: 'Pro Sitter App for Childcare Nanny Agencies' },
  { path: '/pro-sitter-app-for-uk-childcare-nanny-agencies', component: ProSitterAppUK, name: 'Pro Sitter App for UK Childcare Nanny Agencies' },
  { path: '/app-for-dental-staffing-agencies', component: DentalAgencyApp, name: 'App for Dental Staffing Agencies' },
  { path: '/app-for-medical-staffing-agencies', component: MedicalAgencyApp, name: 'App for Medical Staffing Agencies' },
  { path: '/app-for-elderly-care-staffing-agencies', component: ElderlyCareApp, name: 'App for Elderly Companion Care Staffing Agencies' },
  { path: '/caregiver-portfolio-manager', component: PortfolioManager, name: 'Portfolio Manager'},
  { path: '/newborn-care-specialist-software', component: NewbornCare, name: 'Newborn Care Specialist Software'},
  { path: '/au-pair-agency-software', component: AuPairAgencySoftware, name: 'Au Pair Agency Software' },

  { path: '/contact', component: Contact, name: 'Contact' },
  { path: '/start-a-conversation', component: TicketForm, name: 'TicketForm' },
  { path: '/directory', component: Directory, name: 'Directory' },

  { path: '/demo-video', component: DemoVideo, name: 'Demo Video' },
  { path: '/demo-nanny-agency-software', component: DemoVideoNanny, name: 'Demo Nanny Agency Software' },
  { path: '/dental-demo-video', component: DemoVideoDental, name: 'Dental Demo Video' },
  { path: '/dental-staffing-agency-software-demo-video', component: DemoVideoDental, name: 'Dental Staffing Agency Software Demo Video' },
  { path: '/household-demo-video', component: DemoVideoHousehold, name: 'Household Demo Video' },
  { path: '/household-staffing-agency-software-demo-video', component: DemoVideoHousehold, name: 'Household Staffing Agency Software Demo Video' },
  { path: '/staffing-demo-video', component: DemoVideoStaffing, name: 'Staffing Demo Video' },
  { path: '/staffing-agency-software-demo-video', component: DemoVideoStaffing, name: 'Staffing Agency Software Demo Video' },
  { path: '/va-demo-video', component: DemoVideoVA, name: 'VA Demo Video' },
  { path: '/elderly-care-staffing-agency-software-demo-video', component: DemoVideoElderlyCare, name: 'Elderly Care Staffing Agency Software Demo Video' },
  { path: '/backup-care-assistant', component: BackupCareAssistant, name: 'Backup Care Assistant' },
  { path: '/demo-video-event-childcare-management-software', component: DemoVideoEvent, name: 'Demo Video Event Childcare Management Software' },
  { path: '/demo-video-nanny-sitter-agency-app', component: DemoVideoApp, name: 'Demo Video Nanny Sitter Agency App' },
  { path: '/newborn-care-specialist-doula-business-management-software-demo-video', component: DemoVideoNewbornCare, name: 'Newborn Care Specialist Doula Business Management Software Demo Video' },
  
  { path: '/book-demo', component: BookDemo, name: 'Book Demo' },
  { path: '/book-app-demo', component: BookDemoApp, name: 'Book App Demo' },
  { path: '/book-demo-portfolio-manager', component: BookDemoPortfolioManager, name: 'Book Demo Portfolio Manager' },
  { path: '/demo', component: BookDemoGeneral, name: 'Book Demo General' },
  { path: '/book-demo-event-childcare', component: BookDemoEventChildcare, name: 'Book Demo Event Childcare' },
  { path: '/book-demo-rewards-incentives', component: BookDemoRewardsIncentives, name: 'Book Demo Rewards Incentves' },
  { path: '/book-demo-newborn-care-professional-software', component: BookDemoNewbornCare, name: 'Book Demo Newborn Care Professional Software' },
  { path: '/book-demo-cleaning-agency-software', component: BookDemoCleaningAgency, name: 'Book Demo Cleaning Agency Software' },
  { path: '/jobs', component: Jobs, name: 'Jobs' },
  { path: '/thank-you', component: ThankYou, name: 'Thank You' },
  { path: '/thankyou', component: ThankYou2, name: 'Thank You 2' },
  { path: '/thank-you-app', component: ThankYouApp, name: 'Thank You App' },

  { path: '/meet-danny', component: MeetDanny, name: 'Meet Danny' },
  { path: '/meet-aakash', component: MeetAakash, name: 'Meet Aakash' },
  { path: '/meet-falak', component: MeetFalak, name: 'Meet Falak' },
  { path: '/meet-alejandro', component: MeetAlejandro, name: 'Meet Alejandro' },

  { path: '/stripe-connect-confirmation', component: StripeConnectConfirmation, name: 'Stripe Connect Confirmation' },

  // Community Conversations
  { path: '/how-use-linkedin-grow-agency', component: HowToUseLinkedin, name: 'How to Use LinkedIn to Grow Your Agency' },
  { path: '/effective-hiring-tips-for-agencies', component: EffectiveHiringTips, name: 'Effective Hiring Tips For Agencies' },
  { path: '/Marketing-Emails-Webinars-Podcasts', component: MarketingEmailsWebinarsPodcasts, name: 'Marketing Emails Webinars Podcasts' },
  { path: '/Event-Care', component:EventCare, name: 'Event Care' },
  { path: '/Creative-Ways-To-Get-New-Clients', component:CreativeWaysToGetNewClients, name: 'Creative Ways To Get New Clients' },
  { path: '/Using-Enginehire-Email-to-Engage-Clients-and-Candidates', component:UsingEnginehireEmailtoEngageClientsandCandidates, name: 'Using Enginehire Email to Engage Clients and Candidates' },
  { path: '/Effective-Hiring-Tips-For-Your-Agencys-Staffing-and-Your-Candidate-Recruiting', component:EffectiveHiringTipsForYourAgencysStaffingandYourCandidateRecruiting, name: 'Effective Hiring Tips For Your Agencys Staffing and Your Candidate Recruiting' },

  // Webinars
  { path: '/models-of-nanny-care', component: ModelsOfNannyCare, name: 'Models Of Nanny Care' },

  // Tutorials
  { path: '/how-to-sell-gift-cards', component: HowToSellGiftCards, name: 'How to Sell Gift Cards' },
]

export default new VueRouter({ mode: 'history', routes })



// WEBPACK FOOTER //
// ./src/router.js